import { Component, Injector, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { AumBreadcrumbComponentItem, IPageHeader } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { CompaniesProvider } from '../../../../../../aumico-lib-companies-fe/src/lib';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { BasePageComponent } from '../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'app-company-details-page',
    template: `<app-aumico-layout hideFooter="true">
        <ng-container *ngIf="showCompaniesHeader" header>
            <ham-page-header [title]="pageHeader.value" [backButtonRoute]="['../overview']"></ham-page-header>

            <ham-page-tab-navigation [navigationItems]="activeNavigationTabs"></ham-page-tab-navigation>
        </ng-container>
        <ng-container content>
            <router-outlet></router-outlet>
        </ng-container>
    </app-aumico-layout>`,
})
export class CompanyDetailsPage extends BasePageComponent implements OnInit {
    //labels
    readonly companyProfileLabel = RouteLabels.COMPANY_PROFILE;
    readonly finStatementsLabel = RouteLabels.PROJECT_LIST;

    //paths
    readonly companyProfilePath = Paths.PROFILE;
    readonly finstatementsPath = Paths.PROJECT;

    readonly breadcrumbItems: AumBreadcrumbComponentItem[] = [
        {
            displayName: RouteLabels.COMPANIES_LIST,
            routerLink: '../',
        },
    ];
    pageHeader: IPageHeader = {
        isLocalizedKey: false,
        value: RouteLabels.COMPANIES_LIST,
    };

    activeNavigationTabs: {
        routerLink: string;
        tabLabelKey: string;
    }[] = [
            {
                routerLink: Paths.PROJECT,
                tabLabelKey: RouteLabels.PROJECT_LIST,
            },
            {
                routerLink: Paths.PROFILE,
                tabLabelKey: RouteLabels.COMPANY_PROFILE,
            },
            {
                routerLink: Paths.ANALYTICS,
                tabLabelKey: RouteLabels.COMPANY_ANALYTICS,
            },
            {
                routerLink: Paths.INTEGRATIONS,
                tabLabelKey: RouteLabels.COMPANY_INTEGRATIONS,
            },
        ];

    showCompaniesHeader = true;

    constructor(injector: Injector, private companiesProvider: CompaniesProvider) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.companiesProvider
            .getSelectedCompanyById$()
            .pipe(
                filter((company) => company != null),
                untilDestroyed(this),
            )
            .subscribe((company) => {
                this.pageHeader = {
                    isLocalizedKey: false,
                    value: company.label ? company.name + ' (' + company.label + ')' : company.name,
                };
            });
        const companyId = this.activatedRoute.snapshot.params['companyId'];

        this.companiesProvider.dispatchCompanyById(companyId);

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                untilDestroyed(this),
            )
            .subscribe((event: NavigationEnd) => {
                this.showCompaniesHeader = !this.hasAtLeastTwoSegmentsAfterProject(event.urlAfterRedirects);
            });
    }

    hasAtLeastTwoSegmentsAfterProject(url: string) {
        // Regular expression to match 'project' followed by at least two segments
        const regex = /project\/[^\/]+\/[^\/]+/;
        return regex.test(url);
    }
}
